import cn from "classnames";
import type { ReactNode } from "react";

export interface TabItem {
  id: string;
  label: string;
  icon?: ReactNode;
  count?: number;
}

interface TabsProps {
  items: TabItem[];
  activeId: string;
  onChange: (id: string) => void;
  className?: string;
  color?: "primary" | "black";
}

export function Tabs({ items, activeId, onChange, className, color = "primary" }: TabsProps) {
  return (
    <div className={cn("flex gap-6 border-b border-alpha-black-10", className)}>
      {items.map((item) => {
        const isActive = item.id === activeId;

        return (
          <button
            key={item.id}
            onClick={() => onChange(item.id)}
            className={cn(
              "py-2 text-grey-400 text-label-sm cursor-pointer flex items-center gap-2",
              isActive &&
                (color === "primary"
                  ? "content-action-brand border-b-2 background-brand-stroke"
                  : "content-base-primary border-b-2 background-base-stroke"),
            )}>
            {item.icon && <span className="shrink-0">{item.icon}</span>}
            {item.label}
            {item.count != null && item.count > 0 && (
              <span
                className={cn(
                  "w-5 h-5 px-1.5 flex items-center justify-center rounded-md text-label-xs",
                  isActive
                    ? color === "primary"
                      ? "background-brand-fill text-white"
                      : "background-static-black content-base-inverse"
                    : "surface-component-fill content-base-tertiary",
                )}>
                {item.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
